
export const currencySymbols = [
  { label: "usd", value: "$" },
  { label: "gbp", value: "£" },
];

export function getCurrencySymbol(code) {
  if (!code) return "$";
  const match = currencySymbols.find(
    (item) => item.label === String(code).toLowerCase()
  );
  return match ? match.value : "$";
}
